import { Routes } from '@angular/router';
import { AreasEfectivasComponent } from 'src/app/pages/estudio/areas-efectivas/areas-efectivas.component';
import { DatosGeneralesComponent } from 'src/app/pages/estudio/datos-generales/datos-generales.component';
import { DescripcionProyectoComponent } from 'src/app/pages/estudio/descripcion-proyecto/descripcion-proyecto.component';
import { ImpactoAmbientalComponent } from 'src/app/pages/estudio/impacto-ambiental/impacto-ambiental.component';
import { LineaBaseComponent } from 'src/app/pages/estudio/linea-base/linea-base.component';
import { ManejoAmbientalComponent } from 'src/app/pages/estudio/manejo-ambiental/manejo-ambiental.component';
import { MapaComponent } from 'src/app/pages/estudio/mapa/mapa.component';
import { ParticipacionCiudadanaComponent } from 'src/app/pages/estudio/participacion-ciudadana/participacion-ciudadana.component';
import { SeguimientoComponent } from 'src/app/pages/estudio/seguimiento/seguimiento.component';
import { ValoracionEconomicaComponent } from 'src/app/pages/estudio/valoracion-economica/valoracion-economica.component';


export const ESTUDIO_DATOS_PROYECTO_ROUTES: Routes = [
    { path: 'general', component: DatosGeneralesComponent },
    { path: 'seguimiento', component: SeguimientoComponent },
    { path: 'areas', component: AreasEfectivasComponent },
    { path: 'descripcion', component: DescripcionProyectoComponent },
    { path: 'linea-base', component: LineaBaseComponent },
    { path: 'participacion', component: ParticipacionCiudadanaComponent },

    { path: 'i-ambiental', component: ImpactoAmbientalComponent },
    { path: 'm-ambiental', component: ManejoAmbientalComponent },
    { path: 'valoracion', component: ValoracionEconomicaComponent },
    { path: 'mapa', component: MapaComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'general' }
];